import { NonTypedTranslation } from '@qapline/translations';

export type TInvoiceLanguageCode = 'cs' | 'en' | 'de';

export const getInvoiceOrderLanguageOptions = (
    t: NonTypedTranslation,
): {
    value: TInvoiceLanguageCode;
    label: string;
}[] => {
    const codes: TInvoiceLanguageCode[] = ['cs', 'en', 'de'];
    return codes.map((code) => ({
        value: code,
        label: t(`invoicing.form.languages.${code}`),
    }));
};
